// import React, { memo, useCallback } from 'react';
// import { TableRow, TableCell, TextField, Button, Typography } from '@mui/material';
// import Select from 'react-select';
// import CreatableSelect from 'react-select/creatable';
// import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
// import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
// import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
// import InfoIcon from '@mui/icons-material/Info';
// import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
// import { toast } from 'react-toastify';
// import DialogBox from "../DialogBox/DialogBox";
// import Dialog from '@mui/material/Dialog';
// import DialogTitle from '@mui/material/DialogTitle';
// import DialogContent from '@mui/material/DialogContent';
// import DialogActions from '@mui/material/DialogActions';
// import CancelIcon from "@mui/icons-material/Cancel";

// const ObservationRow = memo(({
//   observation,
//   index,
//   isEditing,
//   currentEditedRow,
//   areaOptions,
//   getCategoryOptions,
//   criticalityOptions,
//   customSelectStylesCreatable,
//   handleCellEdit,
//   handleImageUpload,
//   handleOpenImageDialog,
//   getObservationVariants,
//   handleDeleteRow,
//   onObservationChange,
//   handleDialogBoxObservation,
//   dialog,
//   confirmationShown,
//   selectedObservation,
//   handleCloseImageDialog,
//   openDialog,
//   setSelectedImage,
//   handleRemoveImage

// }) => {
//   const isRowDisabled = isEditing && currentEditedRow !== index;
//   const isVariant = observation.variant === true;

//   // Memoized handlers
//   const handleAreaChange = useCallback((selectedOption) => {
//     if (selectedOption) {
//       onObservationChange(index, { area: selectedOption.value });
//       handleCellEdit(selectedOption, index, "area", observation.area, observation);
//     }
//   }, [index, observation.area, handleCellEdit, onObservationChange]);

//   const handleCategoryChange = useCallback((selectedOption) => {
//     if (selectedOption) {
//       onObservationChange(index, { category: selectedOption.value });
//       handleCellEdit(selectedOption, index, "category", observation.category, observation);
//     }
//   }, [index, observation.category, handleCellEdit, onObservationChange]);

//   const handleCheckPointChange = useCallback((e) => {
//     const newValue = e.target.value;
//     const proceed = handleCellEdit(
//       { ...e, target: { ...e.target, textContent: newValue } },
//       index,
//       "check_points",
//       observation.check_points,
//       { ...observation, check_points: newValue }
//     );
//     if (proceed === false) return;
//     if (newValue !== observation.check_points) {
//       onObservationChange(index, { check_points: newValue });
//     }
//   }, [index, observation, handleCellEdit, onObservationChange]);

//   const handleObservationFieldChange = useCallback((e) => {
//     if (currentEditedRow !== -1 && currentEditedRow !== index) {
//       toast.warning("Please save the current row before editing another.");
//       return;
//     }

//     const newValue = e.target.value;

//     // For first-time edit, check if confirmation is needed
//     if (!observation.hasEdited && !confirmationShown) {
//       const allowed = handleCellEdit(
//         { ...e, target: { ...e.target, textContent: newValue } },
//         index,
//         "observation",
//         observation.observation,
//         { ...observation, observation: newValue }
//       );

//       // If dialog is shown (returns false), don't update state yet
//       if (allowed === false) {
//         return;
//       }
//     } else {
//       // For subsequent edits or after confirmation, just validate
//       const proceed = handleCellEdit(
//         { ...e, target: { ...e.target, textContent: newValue } },
//         index,
//         "observation",
//         observation.observation,
//         { ...observation, observation: newValue }
//       );

//       if (proceed === false) return;
//     }

//     // Update the state
//     onObservationChange(index, { observation: newValue, hasEdited: true });
//   }, [index, observation, currentEditedRow, confirmationShown, handleCellEdit, onObservationChange]);

//   const handleCriticalityChange = useCallback((selectedOption) => {
//     if (currentEditedRow !== -1 && currentEditedRow !== index) {
//       toast.warning("Please save the current row before editing another.");
//       return;
//     }
//     if (selectedOption) {
//       onObservationChange(index, { criticality: selectedOption.value });
//       handleCellEdit(selectedOption, index, "criticality", observation.criticality, observation);
//     }
//   }, [index, observation.criticality, currentEditedRow, handleCellEdit, onObservationChange]);

//   const handleRecommendationChange = useCallback((e) => {
//     const newValue = e.target.value;
//     const proceed = handleCellEdit(
//       { ...e, target: { ...e.target, textContent: newValue } },
//       index,
//       "recommendations",
//       observation.recommendations,
//       { ...observation, recommendations: newValue }
//     );
//     if (proceed === false) return;
//     if (newValue !== observation.recommendations) {
//       onObservationChange(index, { recommendations: newValue, hasEdited: true });
//     }
//   }, [index, observation, handleCellEdit, onObservationChange]);

//   const handleReferenceChange = useCallback((e) => {
//     const newValue = e.target.value;
//     const proceed = handleCellEdit(
//       { ...e, target: { ...e.target, textContent: newValue } },
//       index,
//       "is_reference",
//       observation.is_reference,
//       { ...observation, is_reference: newValue }
//     );
//     if (proceed === false) return;
//     if (newValue !== observation.is_reference) {
//       onObservationChange(index, { is_reference: newValue, hasEdited: true });
//     }
//   }, [index, observation, handleCellEdit, onObservationChange]);

//   return (
//     <TableRow
//       className={
//         (isEditing && currentEditedRow === index) || !isEditing
//           ? "even-row"
//           : "odd-row"
//       }
//       style={
//         observation.variant === true
//           ? { backgroundColor: "#f2f2f2" }
//           : {}
//       }
//     >
//       <TableCell>{index + 1}</TableCell>

//       {/* Areas */}
//       <TableCell className="editable-cell" style={{ height: "100px" }}>
//         <div className="cell-content">
//           <CreatableSelect
//             styles={{
//               ...customSelectStylesCreatable,
//               color: isRowDisabled || isVariant ? "grey" : "black",
//             }}
//             placeholder="Area"
//             options={areaOptions().length > 0 ? areaOptions() : []}
//             noOptionsMessage={() => "No options"}
//             value={
//               observation.area
//                 ? { label: observation.area, value: observation.area }
//                 : null
//             }
//             isSearchable
//             onChange={handleAreaChange}
//             isDisabled={isRowDisabled || isVariant}
//             menuPlacement="auto"
//           />
//         </div>
//         {!observation.variant && (
//           <EditOutlinedIcon
//             className="edit-icon"
//             fontSize="small"
//             onClick={(e) => {
//               e.stopPropagation();
//               if (isRowDisabled || isVariant) {
//                 toast.warning("Please save changes in the currently edited row before editing another row.");
//               }
//             }}
//           />
//         )}
//       </TableCell>

//       {/* Category */}
//       <TableCell className="editable-cell" style={{ height: "100px" }}>
//         <div className="cell-content">
//           <CreatableSelect
//             styles={customSelectStylesCreatable}
//             placeholder="Category..."
//             options={getCategoryOptions(observation.area)}
//             noOptionsMessage={() => "No options"}
//             value={
//               observation.category
//                 ? { label: observation.category, value: observation.category }
//                 : null
//             }
//             isSearchable
//             onChange={handleCategoryChange}
//             isDisabled={isRowDisabled || isVariant}
//             menuPlacement="auto"
//           />
//         </div>
//         {!observation.variant && (
//           <EditOutlinedIcon
//             className="edit-icon"
//             fontSize="small"
//             onClick={(e) => {
//               e.stopPropagation();
//               if (isRowDisabled || isVariant) {
//                 toast.warning("Please save changes in the currently edited row before editing another row.");
//               }
//             }}
//           />
//         )}
//       </TableCell>

//       {/* Check Point */}
//       <TableCell className="editable-cell" style={{ height: "100px" }}>
//         <div
//           className="cell-content"
//           style={{
//             color: isRowDisabled || isVariant ? "grey" : "black",
//             marginRight: "10px"
//           }}
//         >
//           <TextField
//             id={`outlined-textarea-${index}`}
//             value={observation.check_points || ''}
//             onChange={handleCheckPointChange}
//             onBlur={(e) => {
//               handleCellEdit(e, index, "check_points", observation.check_points, observation);
//             }}
//             sx={{ width: "200px" }}
//             InputProps={{
//               sx: { fontSize: "10px" },
//               disabled: currentEditedRow !== -1 && currentEditedRow !== index,
//             }}
//             placeholder="Check Point"
//             variant="outlined"
//             size="small"
//             fullWidth
//             multiline
//             minRows={1.5}
//             maxRows={10}
//           />
//         </div>
//         {!observation.variant && (
//           <EditOutlinedIcon
//             onClick={(e) =>
//               isEditing
//                 ? handleCellEdit(
//                     e,
//                     index,
//                     "check_points",
//                     observation.check_points,
//                     observation
//                   )
//                 : null
//             }
//             className="edit-icon"
//             fontSize="small"
//           />
//         )}
//       </TableCell>

//       {/* Observation */}
//       <TableCell className="editable-cell" style={{ height: "100px" }}>
//         <div
//           className="cell-content"
//           style={{
//             color: isRowDisabled || isVariant ? "grey" : "black",
//             marginRight: "10px"
//           }}
//         >
//           <TextField
//             id={`outlined-textarea-obs-${index}`}
//             placeholder="Observation"
//             value={observation.observation || ''}
//             onChange={handleObservationFieldChange}
//             sx={{ width: "200px" }}
//             InputProps={{
//               sx: { fontSize: "10px" },
//               disabled: currentEditedRow !== -1 && currentEditedRow !== index,
//             }}
//             variant="outlined"
//             size="small"
//             fullWidth
//             multiline
//             minRows={1.5}
//             maxRows={10}
//           />
//           <DialogBox dialog={dialog} handleDialogBox={handleDialogBoxObservation} />
//         </div>
//         {!observation.variant && (
//           <EditOutlinedIcon
//             onClick={(e) =>
//               isEditing
//                 ? handleCellEdit(
//                     e,
//                     index,
//                     "observation",
//                     observation.observation,
//                     observation
//                   )
//                 : null
//             }
//             className="edit-icon"
//             fontSize="small"
//           />
//         )}
//       </TableCell>

//       {/* Criticality */}
//       <TableCell className="editable-cell" style={{ height: "100px" }}>
//         <Select
//           styles={customSelectStylesCreatable}
//           placeholder="Criticality"
//           options={criticalityOptions.length > 0 ? criticalityOptions : []}
//           noOptionsMessage={() => "No options"}
//           value={
//             observation.criticality
//               ? { label: observation.criticality, value: observation.criticality }
//               : null
//           }
//           isSearchable
//           onChange={handleCriticalityChange}
//           isDisabled={isRowDisabled || isVariant}
//           menuPlacement="auto"
//         />
//         {!observation.variant && (
//           <EditOutlinedIcon
//             className="edit-icon"
//             fontSize="small"
//             onClick={(e) => {
//               e.stopPropagation();
//               if (isRowDisabled || isVariant) {
//                 toast.warning("Please save changes in the currently edited row before editing another row.");
//               }
//             }}
//           />
//         )}
//       </TableCell>

//       {/* Recommendations */}
//       <TableCell className="editable-cell">
//         <div
//           className="cell-content"
//           style={{
//             color: isRowDisabled || isVariant ? "grey" : "black",
//             marginRight: "10px"
//           }}
//         >
//           <TextField
//             id={`outlined-textarea-rec-${index}`}
//             value={observation.recommendations || ''}
//             placeholder="Recommendations"
//             onChange={handleRecommendationChange}
//             onBlur={(e) => {
//               const latestValue = e.target.value;
//               handleCellEdit(
//                 { ...e, target: { ...e.target, textContent: latestValue } },
//                 index,
//                 "recommendations",
//                 observation.recommendations,
//                 { ...observation, recommendations: latestValue }
//               );
//             }}
//             sx={{ width: "200px" }}
//             InputProps={{
//               sx: { fontSize: "10px" },
//               disabled: currentEditedRow !== -1 && currentEditedRow !== index,
//             }}
//             variant="outlined"
//             size="small"
//             fullWidth
//             multiline
//             minRows={1.5}
//             maxRows={10}
//           />
//         </div>
//         {!observation.variant && (
//           <EditOutlinedIcon
//             onClick={(e) =>
//               isEditing
//                 ? handleCellEdit(
//                     e,
//                     index,
//                     "recommendations",
//                     observation.recommendations,
//                     observation
//                   )
//                 : null
//             }
//             className="edit-icon"
//             fontSize="small"
//           />
//         )}
//       </TableCell>

//       {/* Is Reference */}
//       <TableCell className="editable-cell" style={{ height: "100px" }}>
//         <div
//           className="cell-content"
//           style={{
//             color: isRowDisabled || isVariant ? "grey" : "black",
//             marginRight: "10px"
//           }}
//         >
//           <TextField
//             id={`outlined-textarea-ref-${index}`}
//             value={observation.is_reference || ''}
//             placeholder="Is Reference"
//             onChange={handleReferenceChange}
//             onBlur={(e) => {
//               const latestValue = e.target.value;
//               handleCellEdit(
//                 { ...e, target: { ...e.target, textContent: latestValue } },
//                 index,
//                 "is_reference",
//                 observation.is_reference,
//                 { ...observation, is_reference: latestValue }
//               );
//             }}
//             sx={{ width: "200px" }}
//             InputProps={{
//               sx: { fontSize: "10px" },
//               disabled: currentEditedRow !== -1 && currentEditedRow !== index,
//             }}
//             variant="outlined"
//             size="small"
//             fullWidth
//             multiline
//             minRows={1.5}
//             maxRows={10}
//           />
//         </div>
//         {!observation.variant && (
//           <EditOutlinedIcon
//             onClick={(e) =>
//               isEditing
//                 ? handleCellEdit(
//                     e,
//                     index,
//                     "is_reference",
//                     observation.is_reference,
//                     observation
//                   )
//                 : null
//             }
//             className="edit-icon"
//             fontSize="small"
//           />
//         )}
//       </TableCell>

//       {/* Photo Upload */}
//    <TableCell>
//                               <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "15px" }}>
//                                 <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "6px 0", border: "1px solid grey", borderRadius: "5px", width: "100px", cursor: isEditing && currentEditedRow !== index ? "not-allowed" : "pointer", position: "relative", background: isEditing && currentEditedRow !== index ? "#f0f0f0" : "white", opacity: isEditing && currentEditedRow !== index ? 0.6 : 1 }}>
//                                   <CloudUploadOutlinedIcon size={30} />
//                                   <input type="file" accept="image/*" multiple onChange={(e) => handleImageUpload(index, e.target.files)}
//                                     style={{ position: "absolute", width: "100%", height: "100%", top: 0, left: 0, opacity: 0, cursor: isEditing && currentEditedRow !== index ? "not-allowed" : "pointer" }}
//                                     disabled={isEditing && currentEditedRow !== index} />
//                                 </div>
//                                 <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "6px 0", border: "1px solid grey", borderRadius: "5px", width: "100px", cursor: "pointer" }} onClick={() => handleOpenImageDialog(index, observation)}>
//                                   <InsertPhotoOutlinedIcon size={30} />
//                                 </div>
//                               </div>
//                               {selectedObservation.image && (
//                                 <Dialog onClose={handleCloseImageDialog} open={openDialog} maxWidth={false}
//                                 PaperProps={{
//     sx: {
//       border: "1px solid black",       
//       borderRadius: "10px",          
//     },
//   }}>

//                                   <DialogTitle>Uploaded Images</DialogTitle>
//                                   <DialogContent dividers>

//                                     {selectedObservation.image.imageUrls?.length > 0 ? (
//                                       <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "10px" }}>
//                                         {selectedObservation.image.imageUrls.map((imageUrl, imgIndex) => (
//                                           <div style={{ display: "flex" }} key={imgIndex}>
//                                             <img src={imageUrl} alt={`Image ${imgIndex + 1}`} onClick={() => setSelectedImage(imageUrl)} // className="photo-image-saved"
//                                               style={{ cursor: "pointer", width: "200px", height: "200px" }} />
//                                             <CancelIcon className="cancel-icon" onClick={() => handleRemoveImage(selectedObservation.index, imgIndex)} />
//                                           </div>
//                                         ))}
//                                       </div>
//                                     ) : (
//                                       <Typography gutterBottom>No File Uploaded</Typography>
//                                     )}
//                                   </DialogContent>
//                                   <DialogActions>
//                                     <Button onClick={handleCloseImageDialog}>Close</Button>
//                                   </DialogActions>
//                                 </Dialog>
//                               )}
//                             </TableCell>

//       {/* Actions */}
//       <TableCell>
//         <div style={{ display: "flex", justifyContent: "center" }}>
//           {!observation.variant && (
//             <InfoIcon
//               onClick={
//                 isRowDisabled
//                   ? undefined
//                   : () => getObservationVariants(observation.observation, index)
//               }
//               style={{
//                 cursor: isRowDisabled ? "not-allowed" : "pointer",
//                 opacity: isRowDisabled ? 0.5 : 1,
//               }}
//             />
//           )}
//           <DeleteForeverIcon
//             onClick={
//               isRowDisabled
//                 ? undefined
//                 : () => handleDeleteRow(index)
//             }
//             style={{
//               cursor: isRowDisabled ? "not-allowed" : "pointer",
//               opacity: isRowDisabled ? 0.5 : 1,
//             }}
//             aria-disabled={isRowDisabled}
//           />
//         </div>
//       </TableCell>
//     </TableRow>
//   );
// }, (prevProps, nextProps) => {
//   return (
//     prevProps.observation === nextProps.observation &&
//     prevProps.isEditing === nextProps.isEditing &&
//     prevProps.currentEditedRow === nextProps.currentEditedRow &&
//     prevProps.confirmationShown === nextProps.confirmationShown &&
//     prevProps.dialog.open === nextProps.dialog.open  &&
//       prevProps.openImageDialog === nextProps.openImageDialog &&
//   prevProps.selectedObservation === nextProps.selectedObservation
//   );
// });

// ObservationRow.displayName = 'ObservationRow';

// export default ObservationRow;











import React, { memo, useCallback, useEffect } from 'react';
import { TableRow, TableCell, TextField, Button, Typography, Tooltip } from '@mui/material';
import Select from 'react-select';
import CreatableSelect from 'react-select/creatable';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloudUploadOutlinedIcon from '@mui/icons-material/CloudUploadOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import InfoIcon from '@mui/icons-material/Info';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { toast } from 'react-toastify';
import DialogBox from "../DialogBox/DialogBox";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CancelIcon from "@mui/icons-material/Cancel";
import { AddPhotoAlternateOutlined } from '@mui/icons-material';

const ObservationRow = memo(({
  observation,
  index,
  isEditing,
  currentEditedRow,
  areaOptions,
  // areaList,
  getCategoryOptions,
  criticalityOptions,
  customSelectStylesCreatable,
  handleCellEdit,
  handleImageUpload,
  handleOpenImageDialog,
  getObservationVariants,
  handleDeleteRow,
  onObservationChange,
  // handleDialogBoxObservation,
  // dialog,
  // confirmationShown,
  isConfirmed,
  // selectedObservation,
  // handleCloseImageDialog,
  // openDialog,
  // setSelectedImage,
  // handleRemoveImage,
  selectedObservations,
  bulkUploadedImages,
  bulkUploadedImagesRef,
  handleAssignBulkImageToRow,
  handleUnassignBulkImageFromRow,
  openGallery,
  setOpenGallery,
  setObsIndex,
  handleOpenGallery,
}) => {
  const isRowDisabled = isEditing && currentEditedRow !== index;
  const isVariant = observation.variant === true;
  // console.log(observation)
  // console.log('isRowDisabled: ',isRowDisabled);
  // useEffect(() => {
  //     console.log('-- inn bulkUploadedImages:',bulkUploadedImages);
  //   }, [bulkUploadedImages]);

  // Memoized handlers
  const handleAreaChange = useCallback((selectedOption) => {
    if (selectedOption) {
      onObservationChange(index, { area: selectedOption.value });
      handleCellEdit(selectedOption, index, "area", observation.area, observation);
    }
  }, [index, observation.area, handleCellEdit, onObservationChange]);

  const handleCategoryChange = useCallback((selectedOption) => {
    if (selectedOption) {
      onObservationChange(index, { category: selectedOption.value });
      handleCellEdit(selectedOption, index, "category", observation.category, observation);
    }
  }, [index, observation.category, handleCellEdit, onObservationChange]);

  const handleCheckPointChange = useCallback((e) => {
    const newValue = e.target.value;
    const proceed = handleCellEdit(
      { ...e, target: { ...e.target, textContent: newValue } },
      index,
      "check_points",
      observation.check_points,
      { ...observation, check_points: newValue }
    );
    if (proceed === false) return;
    if (newValue !== observation.check_points) {
      onObservationChange(index, { check_points: newValue });
    }
  }, [index, observation, handleCellEdit, onObservationChange]);

  const handleObservationFieldChange = useCallback((e) => {
    if (currentEditedRow !== -1 && currentEditedRow !== index) {
      toast.warning("Please save the current row before editing another.");
      return;
    }

    const newValue = e.target.value;

    // Simplified - handleCellEdit now checks confirmedRows internally
    const proceed = handleCellEdit(
      { ...e, target: { ...e.target, textContent: newValue } },
      index,
      "observation",
      observation.observation,
      { ...observation, observation: newValue }
    );

    if (proceed === false) return;

    // Update the state
    onObservationChange(index, { observation: newValue, hasEdited: true });
  }, [index, observation, currentEditedRow, handleCellEdit, onObservationChange]);


  const handleCriticalityChange = useCallback((selectedOption) => {
    if (currentEditedRow !== -1 && currentEditedRow !== index) {
      toast.warning("Please save the current row before editing another.");
      return;
    }
    if (selectedOption) {
      onObservationChange(index, { criticality: selectedOption.value });
      handleCellEdit(selectedOption, index, "criticality", observation.criticality, observation);
    }
  }, [index, observation.criticality, currentEditedRow, handleCellEdit, onObservationChange]);

  const handleRecommendationChange = useCallback((e) => {
    const newValue = e.target.value;
    const proceed = handleCellEdit(
      { ...e, target: { ...e.target, textContent: newValue } },
      index,
      "recommendations",
      observation.recommendations,
      { ...observation, recommendations: newValue }
    );
    if (proceed === false) return;
    if (newValue !== observation.recommendations) {
      onObservationChange(index, { recommendations: newValue, hasEdited: true });
    }
  }, [index, observation, handleCellEdit, onObservationChange]);

  const handleReferenceChange = useCallback((e) => {
    const newValue = e.target.value;
    const proceed = handleCellEdit(
      { ...e, target: { ...e.target, textContent: newValue } },
      index,
      "is_reference",
      observation.is_reference,
      { ...observation, is_reference: newValue }
    );
    if (proceed === false) return;
    if (newValue !== observation.is_reference) {
      onObservationChange(index, { is_reference: newValue, hasEdited: true });
    }
  }, [index, observation, handleCellEdit, onObservationChange]);

  return (
    <TableRow
      className={
        (isEditing && currentEditedRow === index) || !isEditing
          ? "even-row"
          : "odd-row"
      }
      style={
        observation.variant === true
          ? { backgroundColor: "#f2f2f2" }
          : {}
      }
    >
      <TableCell>{index + 1}</TableCell>

      {/* Areas */}
      <TableCell className="editable-cell" style={{ height: "100px" }}>
        <div className="cell-content">
          <CreatableSelect
            styles={{
              ...customSelectStylesCreatable,
              color: isRowDisabled || isVariant ? "grey" : "black",
            }}
            placeholder="Area"
            options={areaOptions().length > 0 ? areaOptions() : []}
            noOptionsMessage={() => "No options"}
            value={
              observation.area
                ? { label: observation.area, value: observation.area }
                : null
            }
            isSearchable
            onChange={handleAreaChange}
            isDisabled={isRowDisabled || isVariant}
            menuPlacement="auto"
            className={observation.area.length ? "" : "error-input"}
          />
        </div>
        {!observation.variant && (
          <EditOutlinedIcon
            className="edit-icon"
            fontSize="small"
            onClick={(e) => {
              e.stopPropagation();
              if (isRowDisabled || isVariant) {
                toast.warning("Please save changes in the currently edited row before editing another row.");
              }
            }}
          />
        )}
      </TableCell>

      {/* Category */}
      <TableCell className="editable-cell" style={{ height: "100px" }}>
        <div className="cell-content">
          <CreatableSelect
            styles={customSelectStylesCreatable}
            placeholder="Category..."
            options={getCategoryOptions(observation.area)}
            noOptionsMessage={() => "No options"}
            value={
              observation.category
                ? { label: observation.category, value: observation.category }
                : null
            }
            isSearchable
            onChange={handleCategoryChange}
            isDisabled={isRowDisabled || isVariant}
            menuPlacement="auto"
          />
        </div>
        {!observation.variant && (
          <EditOutlinedIcon
            className="edit-icon"
            fontSize="small"
            onClick={(e) => {
              e.stopPropagation();
              if (isRowDisabled || isVariant) {
                toast.warning("Please save changes in the currently edited row before editing another row.");
              }
            }}
          />
        )}
      </TableCell>

      {/* Check Point */}
      <TableCell className="editable-cell" style={{ height: "100px" }}>
        <div
          className="cell-content"
          style={{
            color: isRowDisabled || isVariant ? "grey" : "black",
            marginRight: "10px"
          }}
        >
          <TextField
            id={`outlined-textarea-${index}`}
            value={observation.check_points || ''}
            onChange={handleCheckPointChange}
            onBlur={(e) => {
              handleCellEdit(e, index, "check_points", observation.check_points, observation);
            }}
            sx={{ width: "200px" }}
            InputProps={{
              sx: { fontSize: "10px" },
              disabled: currentEditedRow !== -1 && currentEditedRow !== index,
            }}
            placeholder="Check Point"
            variant="outlined"
            size="small"
            fullWidth
            multiline
            minRows={1.5}
            maxRows={10}
          />
        </div>
        {!observation.variant && (
          <EditOutlinedIcon
            onClick={(e) =>
              isEditing
                ? handleCellEdit(
                  e,
                  index,
                  "check_points",
                  observation.check_points,
                  observation
                )
                : null
            }
            className="edit-icon"
            fontSize="small"
          />
        )}
      </TableCell>

      {/* Observation */}
      <TableCell className="editable-cell" style={{ height: "100px" }}>
        <div
          className="cell-content"
          style={{
            color: isRowDisabled || isVariant ? "grey" : "black",
            marginRight: "10px"
          }}
        >
          <TextField
            id={`outlined-textarea-obs-${index}`}
            placeholder="Observation"
            value={observation.observation || ''}
            onChange={handleObservationFieldChange}
            sx={{ width: "200px" }}
            InputProps={{
              sx: { fontSize: "10px" },
              disabled: currentEditedRow !== -1 && currentEditedRow !== index,
            }}
            variant="outlined"
            size="small"
            fullWidth
            multiline
            minRows={1.5}
            maxRows={10}
            className={observation.observation.length ? "" : "error-input"}
          />
          {/* <DialogBox dialog={dialog} handleDialogBox={handleDialogBoxObservation} /> */}
        </div>
        {!observation.variant && (
          <EditOutlinedIcon
            onClick={(e) =>
              isEditing
                ? handleCellEdit(
                  e,
                  index,
                  "observation",
                  observation.observation,
                  observation
                )
                : null
            }
            className="edit-icon"
            fontSize="small"
          />
        )}
      </TableCell>

      {/* Criticality */}
      <TableCell className="editable-cell" style={{ height: "100px" }}>
        <Select
          styles={customSelectStylesCreatable}
          placeholder="Criticality"
          options={criticalityOptions.length > 0 ? criticalityOptions : []}
          noOptionsMessage={() => "No options"}
          value={
            observation.criticality
              ? { label: observation.criticality, value: observation.criticality }
              : null
          }
          isSearchable
          onChange={handleCriticalityChange}
          isDisabled={isRowDisabled || isVariant}
          menuPlacement="auto"
        />
        {!observation.variant && (
          <EditOutlinedIcon
            className="edit-icon"
            fontSize="small"
            onClick={(e) => {
              e.stopPropagation();
              if (isRowDisabled || isVariant) {
                toast.warning("Please save changes in the currently edited row before editing another row.");
              }
            }}
          />
        )}
      </TableCell>

      {/* Recommendations */}
      <TableCell className="editable-cell">
        <div
          className="cell-content"
          style={{
            color: isRowDisabled || isVariant ? "grey" : "black",
            marginRight: "10px"
          }}
        >
          <TextField
            id={`outlined-textarea-rec-${index}`}
            value={observation.recommendations || ''}
            placeholder="Recommendations"
            onChange={handleRecommendationChange}
            onBlur={(e) => {
              const latestValue = e.target.value;
              handleCellEdit(
                { ...e, target: { ...e.target, textContent: latestValue } },
                index,
                "recommendations",
                observation.recommendations,
                { ...observation, recommendations: latestValue }
              );
            }}
            sx={{ width: "200px" }}
            InputProps={{
              sx: { fontSize: "10px" },
              disabled: currentEditedRow !== -1 && currentEditedRow !== index,
            }}
            variant="outlined"
            size="small"
            fullWidth
            multiline
            minRows={1.5}
            maxRows={10}
            className={observation.recommendations.length ? "" : "error-input"}
          />
        </div>
        {!observation.variant && (
          <EditOutlinedIcon
            onClick={(e) =>
              isEditing
                ? handleCellEdit(
                  e,
                  index,
                  "recommendations",
                  observation.recommendations,
                  observation
                )
                : null
            }
            className="edit-icon"
            fontSize="small"
          />
        )}
      </TableCell>

      {/* Is Reference */}
      <TableCell className="editable-cell" style={{ height: "100px" }}>
        <div
          className="cell-content"
          style={{
            color: isRowDisabled || isVariant ? "grey" : "black",
            marginRight: "10px"
          }}
        >
          <TextField
            id={`outlined-textarea-ref-${index}`}
            value={observation.is_reference || ''}
            placeholder="Is Reference"
            onChange={handleReferenceChange}
            onBlur={(e) => {
              const latestValue = e.target.value;
              handleCellEdit(
                { ...e, target: { ...e.target, textContent: latestValue } },
                index,
                "is_reference",
                observation.is_reference,
                { ...observation, is_reference: latestValue }
              );
            }}
            sx={{ width: "200px" }}
            InputProps={{
              sx: { fontSize: "10px" },
              disabled: currentEditedRow !== -1 && currentEditedRow !== index,
            }}
            variant="outlined"
            size="small"
            fullWidth
            multiline
            minRows={1.5}
            maxRows={10}
            className={observation.is_reference.length ? "" : "error-input"}
          />
        </div>
        {!observation.variant && (
          <EditOutlinedIcon
            onClick={(e) =>
              isEditing
                ? handleCellEdit(
                  e,
                  index,
                  "is_reference",
                  observation.is_reference,
                  observation
                )
                : null
            }
            className="edit-icon"
            fontSize="small"
          />
        )}
      </TableCell>

      {/* Photo Upload */}
      <TableCell>
        
        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "15px" }}>
          {/* {bulkUploadedImages.length ? 
            <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "6px 0", border: "1px solid grey", borderRadius: "5px", width: "100px", cursor: isEditing && currentEditedRow !== index ? "not-allowed" : "pointer", position: "relative", background: isEditing && currentEditedRow !== index ? "#f0f0f0" : "white", opacity: isEditing && currentEditedRow !== index ? 0.6 : 1 }}
              onClick={() => {setOpenGallery(true);setObsIndex(index);}}
              >
                <CloudUploadOutlinedIcon size={30} />
              </div>
            :
            <p>Upload Photos</p>
          } */}
          {/* Open Gallery only when this row is the one being edited */}
          {isRowDisabled ?
              observation?.imageUrls?.length > 0 ?
                <Tooltip title="View Images" placement="top">
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "6px 0", border: "1px solid grey", borderRadius: "5px", width: "100px", cursor: "pointer" }} onClick={() => handleOpenImageDialog(observation.sr_no, observation)}>
                      <InsertPhotoOutlinedIcon size={30} />
                    </div>
                  </Tooltip>
                :
                <Tooltip title="click here to go to  Bulk Upload" placement="top">
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      // Can't move the real cursor (browsers block that) — scroll
                      // to top and flash a highlight instead.
                      const el = document.querySelector(".bulk-upload-zone");
                      if (!el) return;
                      el.scrollIntoView({ behavior: "smooth", block: "center" });
                      el.style.transition = "box-shadow 0.3s ease";
                      el.style.boxShadow = "0 0 0 3px #1976d2";
                      setTimeout(() => {
                        el.style.boxShadow = "none";
                      }, 1500);
                    }}
                  >
                    No images uploaded
                  </span>
                </Tooltip>
          : 
          bulkUploadedImages.length > 0 || observation?.imageUrls?.length > 0 ? 
          <Tooltip title="Open Gallery" placement="top">
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "6px 0", border: "1px solid grey", borderRadius: "5px", width: "100px", cursor: "pointer", position: "relative", background: "white", opacity: 1 }}
                onClick={() => {handleOpenGallery(observation,observation.sr_no)}}
                >
                <AddPhotoAlternateOutlined size={30} />
              </div>
            </Tooltip>
          :
          <Tooltip key={index} title="click here to go to  Bulk Upload" placement="top">
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  // Can't move the real cursor (browsers block that) — scroll
                  // to top and flash a highlight instead.
                  const el = document.querySelector(".bulk-upload-zone");
                  if (!el) return;
                  el.scrollIntoView({ behavior: "smooth", block: "center" });
                  el.style.transition = "box-shadow 0.3s ease";
                  el.style.boxShadow = "0 0 0 3px #1976d2";
                  setTimeout(() => {
                    el.style.boxShadow = "none";
                  }, 1500);
                }}
              >
                No images uploaded
              </span>
            </Tooltip>
          }
          {/* {isEditing && currentEditedRow === index ?
            bulkUploadedImages.length > 0 || observation?.imageUrls?.length > 0 ?
            <Tooltip title="Open Gallery ===" placement="top">
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "6px 0", border: "1px solid grey", borderRadius: "5px", width: "100px", cursor: "pointer", position: "relative", background: "white", opacity: 1 }}
                onClick={() => {handleOpenGallery(observation,observation.sr_no)}}
                >
                <AddPhotoAlternateOutlined size={30} />
              </div>
            </Tooltip>
            :
            <Tooltip key={index} title="click here to go to  Bulk Upload" placement="top">
              <span
                style={{ cursor: "pointer" }}
                onClick={() => {
                  // Can't move the real cursor (browsers block that) — scroll
                  // to top and flash a highlight instead.
                  const el = document.querySelector(".bulk-upload-zone");
                  if (!el) return;
                  el.scrollIntoView({ behavior: "smooth", block: "center" });
                  el.style.transition = "box-shadow 0.3s ease";
                  el.style.boxShadow = "0 0 0 3px #1976d2";
                  setTimeout(() => {
                    el.style.boxShadow = "none";
                  }, 1500);
                }}
              >
                Please Upload images
              </span>
            </Tooltip>
            :
            observation?.imageUrls?.length > 0 ?
              <Tooltip title="View Images" placement="top">
                <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "6px 0", border: "1px solid grey", borderRadius: "5px", width: "100px", cursor: "pointer" }} onClick={() => handleOpenImageDialog(observation.sr_no, observation)}>
                  <InsertPhotoOutlinedIcon size={30} />
                </div>
              </Tooltip>
              :
                bulkUploadedImages.length > 0 && (isEditing && currentEditedRow === index) ?
                <Tooltip title="Open Gallery--" placement="top">
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "6px 0", border: "1px solid grey", borderRadius: "5px", width: "100px", cursor: "pointer", position: "relative", background: "white", opacity: 1 }}
                    onClick={() => {handleOpenGallery(observation,observation.sr_no)}}
                    >
                    <AddPhotoAlternateOutlined size={30} />
                  </div>
                </Tooltip>
                :
                <Tooltip title="click here to go to  Bulk Upload" placement="top">
                  <span
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                      // Can't move the real cursor (browsers block that) — scroll
                      // to top and flash a highlight instead.
                      const el = document.querySelector(".bulk-upload-zone");
                      if (!el) return;
                      el.scrollIntoView({ behavior: "smooth", block: "center" });
                      el.style.transition = "box-shadow 0.3s ease";
                      el.style.boxShadow = "0 0 0 3px #1976d2";
                      setTimeout(() => {
                        el.style.boxShadow = "none";
                      }, 1500);
                    }}
                  >
                    No images uploaded
                  </span>
                </Tooltip> }*/
          }
          
          
          {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "6px 0", border: "1px solid grey", borderRadius: "5px", width: "100px", cursor: isEditing && currentEditedRow !== index ? "not-allowed" : "pointer", position: "relative", background: isEditing && currentEditedRow !== index ? "#f0f0f0" : "white", opacity: isEditing && currentEditedRow !== index ? 0.6 : 1 }}>
            <CloudUploadOutlinedIcon size={30} />
            <input type="file" accept="image/jpeg,image/png" multiple onChange={(e) => handleImageUpload(index, e.target.files)}
              style={{ position: "absolute", width: "100%", height: "100%", top: 0, left: 0, opacity: 0, cursor: isEditing && currentEditedRow !== index ? "not-allowed" : "pointer", }}
              disabled={isEditing && currentEditedRow !== index}
              title=""
            />
          </div> */}
          {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "center", padding: "6px 0", border: "1px solid grey", borderRadius: "5px", width: "100px", cursor: "pointer" }} onClick={() => handleOpenImageDialog(observation.sr_no, observation)}>
            <InsertPhotoOutlinedIcon size={30} />
          </div> */}
        </div>
        {/* {selectedObservation.image && (
                                <Dialog onClose={handleCloseImageDialog} open={openDialog} maxWidth={false}
                                PaperProps={{
    sx: {
      border: "1px solid black",       
      borderRadius: "10px",          
    },
  }}>
                                  
                                  <DialogTitle>Uploaded Images</DialogTitle>
                                  <DialogContent dividers>
                                    
                                    {selectedObservation.image.imageUrls?.length > 0 ? (
                                      <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "10px" }}>
                                        {selectedObservation.image.imageUrls.map((imageUrl, imgIndex) => (
                                          <div style={{ display: "flex" }} key={imgIndex}>
                                            <img src={imageUrl} alt={`Image ${imgIndex + 1}`} onClick={() => setSelectedImage(imageUrl)} // className="photo-image-saved"
                                              style={{ cursor: "pointer", width: "200px", height: "200px" }} />
                                            <CancelIcon className="cancel-icon" onClick={() => handleRemoveImage(selectedObservation.index, imgIndex)} />
                                          </div>
                                        ))}
                                      </div>
                                    ) : (
                                      <Typography gutterBottom>No File Uploaded</Typography>
                                    )}
                                  </DialogContent>
                                  <DialogActions>
                                    <Button onClick={handleCloseImageDialog}>Close</Button>
                                  </DialogActions>
                                </Dialog>
                              )} */}
      </TableCell>

      {/* Actions */}
      <TableCell>
        <div style={{ display: "flex", justifyContent: "center" }}>
          {!observation.variant && (
            <InfoIcon
              onClick={
                isRowDisabled
                  ? undefined
                  : () => getObservationVariants(observation.observation, index)
              }
              style={{
                cursor: isRowDisabled ? "not-allowed" : "pointer",
                opacity: isRowDisabled ? 0.5 : 1,
              }}
            />
          )}
          <DeleteForeverIcon
            onClick={
              isRowDisabled
                ? undefined
                : () => {
                    if (window.confirm("Are you sure you want to delete this observation?")) {
                      handleDeleteRow(observation.sr_no || observation.tempId);
                    }
                  }
            }
            style={{
              cursor: isRowDisabled ? "not-allowed" : "pointer",
              opacity: isRowDisabled ? 0.5 : 1,
            }}
            aria-disabled={isRowDisabled}
          />
        </div>
      </TableCell>
    </TableRow>
  );
}, (prevProps, nextProps) => {
  //   return (
  // prevProps.observation === nextProps.observation &&
  //     prevProps.isEditing === nextProps.isEditing &&
  //     prevProps.currentEditedRow === nextProps.currentEditedRow &&
  //     prevProps.confirmationShown === nextProps.confirmationShown 
  //     // prevProps.dialog.open === nextProps.dialog.open
  //   );
  if (prevProps.index !== nextProps.index) return false;
  if (prevProps.currentEditedRow !== nextProps.currentEditedRow) return false;
  if (prevProps.isEditing !== nextProps.isEditing) return false;
  if (prevProps.isConfirmed !== nextProps.isConfirmed) return false; // Change from confirmationShown

  // bulkUploadedImages isn't covered below — without this, pushing new
  // images from the gallery doesn't re-render the row.
  const b1 = prevProps.bulkUploadedImages || [];
  const b2 = nextProps.bulkUploadedImages || [];
  if (b1.length !== b2.length || b1.some((v, i) => v !== b2[i])) return false;

  // Check observation fields
  const prev = prevProps.observation;
  const next = nextProps.observation;

  return (
    prev.criticality === next.criticality &&
    prev.area === next.area &&
    prev.category === next.category &&
    prev.check_points === next.check_points &&
    prev.observation === next.observation &&
    prev.recommendations === next.recommendations &&
    prev.is_reference === next.is_reference &&
    prev.variant === next.variant &&
    // prev.imageUrls === next.imageUrls
    JSON.stringify(prev.imageUrls) === JSON.stringify(next.imageUrls)

  );
});

ObservationRow.displayName = 'ObservationRow';

export default ObservationRow;